// Share-link routing. A shared song lives at `/s/<uuid>` — a real path
// (not a query flag) so the URL reads as a permalink and the Pages SPA
// fallback serves index.html for it (see vite.config navigateFallback).
//
// Nothing else in the app reads location.pathname, so this route
// collides with nothing. parseShareId is the single source of truth
// for "is this a share URL, and for which patch".

// Same shape as the worker's UUID guard (worker/src/patches.ts:50) so a
// path segment that isn't a patch id is rejected before any cloud read.
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Capture the first path segment after /s/, tolerating a trailing slash.
const SHARE_RE = /^\/s\/([^/]+)\/?$/;

/** Returns the lowercased patch id when `pathname` is a valid
 *  `/s/<uuid>` share link, else null. */
export function parseShareId(pathname: string): string | null {
  const m = SHARE_RE.exec(pathname);
  if (!m) return null;
  const id = m[1]!;
  return UUID_RE.test(id) ? id.toLowerCase() : null;
}

/** Absolute share URL for a patch id. `origin` defaults to the current
 *  window origin; pass it explicitly in non-browser contexts (tests). */
export function buildShareUrl(id: string, origin?: string): string {
  const base =
    origin ?? (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base.replace(/\/$/, '')}/s/${id}`;
}
